import { Snippet } from '../../dataModels';

export const rollupDataEntryTableSnippet: Snippet = {
  shiftsummaryDisplyId: '90751c52-23c7-ec11-9146-005056b29cce',
  name: 'AA_RollupDET',
  displayName: 'AA_RollupDET',
  description: null,
  order: 2,
  type: 'RollupDataEntryTable',
  enableEdit: 'True',
  configuration: {
    rowTitleKey: 'Status',
    columnCount: 3,
    matrixCells: null,
    columns: [
      {
        id: 1,
        name: 'Status',
        displayName: 'Status',
        controlType: 'Checkbox',
        controlValues: [],
        visible: 'True',
      },
      {
        id: 2,
        name: 'Col1',
        displayName: 'Col1',
        controlType: 'Text',
        controlValues: [],
        visible: 'True',
      },
      {
        id: 3,
        name: 'Col2',
        displayName: 'Col2',
        controlType: 'DateTime',
        controlValues: [],
        visible: 'True',
      },
    ],
  },
  data: [
    {
      rollupDetails: {
        SourceSnippetDisplayID: '199edd53-22c7-ec11-9146-005056b29cce',
        Asset: 'Field1',
        Author: 'Gabriel, Lucas C /CS',
        CreatedTime: '4/28/2022 6:38:00 PM',
      },
      rowCount: 2,
      rowData: [
        {
          Status: 'False',
          Col1: 'Test 2',
          Col2: '2022-04-28T16:00:00Z',
        },
        {
          Status: 'True',
          Col1: 'Test',
          Col2: '2022-04-27T16:00:00Z',
        },
      ],
    },
    {
      rollupDetails: {
        SourceSnippetDisplayID: 'df6a0f37-23c7-ec11-9146-005056b29cce',
        Asset: 'Field2',
        Author: 'Gabriel, Lucas C /CS',
        CreatedTime: '4/28/2022 6:44:21 PM',
      },
      rowCount: 0,
      rowData: [],
    },
    {
      rollupDetails: {
        SourceSnippetDisplayID: 'b48aade2-22c7-ec11-9146-005056b29cce',
        Asset: 'Field3',
        Author: 'Gabriel, Lucas C /CS',
        CreatedTime: '4/28/2022 6:41:59 PM',
      },
      rowCount: 0,
      rowData: [],
    },
  ],
  count: 0,
  groupSnippets: null,
  enableComment: false,
  isEdited: false,
  maxRows: 10,
  canAddDeleteRows: 'true',
};
